var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 0.5C29.5887 0.5 38 8.91125 38 19.25C38 29.5887 29.5887 38 19.25 38C8.91125 38 0.5 29.5887 0.5 19.25C0.5 8.91125 8.91125 0.5 19.25 0.5ZM2 19.25C2 28.7615 9.7385 36.5 19.25 36.5C28.7615 36.5 36.5 28.7615 36.5 19.25C36.5 9.7385 28.7615 2 19.25 2C9.7385 2 2 9.7385 2 19.25ZM35.0682 31.8862L45.1512 41.97C45.4445 42.2625 45.4445 42.738 45.1512 43.0305L43.0302 45.1515C42.7377 45.4447 42.263 45.4447 41.9697 45.1515L31.8867 35.0677C33.0612 34.128 34.1285 33.0607 35.0682 31.8862Z",
    fill: "url(#paint0_linear_36_1749)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_1749",
    x1: 22.9356,
    y1: 0.5,
    x2: 22.9356,
    y2: 45.3714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6CBD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A4B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.92093fd1db556f52e69f8a47fb813039.svg";
export { ForwardRef as ReactComponent };